const PREFIX = '@APP';

export const ENABLE_MOUSE_CONTROLS = `@APP/ENABLE_MOUSE_CONTROLS`;

export const INIT_USER_DATA = '@APP/INIT_USER_DATA';
export const INIT_USER_DATA_SUCCESS = '@APP/INIT_USER_DATA_SUCCESS';
export const INIT_USER_DATA_ERROR = '@APP/INIT_USER_DATA_ERROR';

export const SET_MENU_ITEMS = `${PREFIX}/SET_MENU_ITEMS`;

export const SET_SCREENS = `${PREFIX}/SET_SCREENS`;
